import { render, staticRenderFns } from "./ModalAulas.vue?vue&type=template&id=2f21c5c0&scoped=true&"
import script from "./ModalAulas.vue?vue&type=script&lang=js&"
export * from "./ModalAulas.vue?vue&type=script&lang=js&"
import style0 from "./ModalAulas.vue?vue&type=style&index=0&id=2f21c5c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f21c5c0",
  null
  
)

export default component.exports